import { IModalDescription } from '@cp/shared/modal';
import type { TariffModalLayoutProps } from '../ui/tariffModalLayout';
import type { SubscriptionConfirmModalLayoutProps } from '../ui/subscriptionConfirmModalLayout';
import type { CopyPromoModalLayoutProps } from '../ui/copyPromoModalLayout';
import type { CardBindingModalLayoutProps } from '../ui/cardBindingModalLayout';
import type { CheckoutModalLayoutProps } from '../ui/checkoutModalLayout';

export const TARIFF_SELECT_MODAL: IModalDescription<TariffModalLayoutProps> = {
  nss: 'tariff-select',
  loader: () => import('../ui/tariffModalLayout').then((module) => module.TariffModalLayout),
};

export const SUBSCRIPTION_CONFIRM_MODAL: IModalDescription<SubscriptionConfirmModalLayoutProps> = {
  nss: 'subscription-confirm',
  loader: () => import('../ui/subscriptionConfirmModalLayout').then((module) => module.SubscriptionConfirmModalLayout),
};

export const COPY_PROMO_MODAL: IModalDescription<CopyPromoModalLayoutProps> = {
  nss: 'copy-promo',
  loader: () => import('../ui/copyPromoModalLayout').then((module) => module.CopyPromoModalLayout),
};

export const CARD_BINDING_MODAL: IModalDescription<CardBindingModalLayoutProps> = {
  nss: 'card-binding',
  loader: () => import('../ui/cardBindingModalLayout').then((module) => module.CardBindingModalLayout),
};

export const CHECKOUT_MODAL: IModalDescription<CheckoutModalLayoutProps> = {
  nss: 'checkout',
  loader: () => import('../ui/checkoutModalLayout').then((module) => module.CheckoutModalLayout),
};
